import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import {
  createInsuranceneedAPI,
  getInsuranceneedAPI,
  getincomeAPI,
  deleteInsuranceneedAPI,
  UpdateInsuranceNeedAPI,
} from "./api"
import {
  createInsuranceNeedFailure,
  createInsuranceNeedSuccess,
  getIncomeFailure,
  getIncomeSuccess,
  getInsuranceNeedFailure,
  getInsuranceNeedSuccess,
  deleteInsuranceNeedFailure,
  deleteInsuranceNeedSuccess,
  updateInsuranceNeedSuccess,
  updateInsuranceNeedFailed,
} from "./action"
import {
  CREATE_INSURANCENEED_START,
  GET_INCOME_START,
  GET_INSURANCENEED_START,
  DELETE_INSURANCE_NEED_START,
  UPDATE_INSURANCE_NEED,
} from "./actiontypes"

function* getinsuranceneedAsync(action) {
  try {
    console.log(action.payload)
    const response = yield call(getInsuranceneedAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
      yield put(getInsuranceNeedSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getInsuranceNeedFailure(error))
  }
}

function* getinsuranceneed() {
  yield takeEvery(GET_INSURANCENEED_START, getinsuranceneedAsync)
}

function* createInsuranceNeedAsync(action) {
  try {
    const response = yield call(createInsuranceneedAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(createInsuranceNeedSuccess(response.data))
    }
  } catch (error) {
    yield put(createInsuranceNeedFailure(error.response.data))
  }
}
function* createInsuranceNeed() {
  yield takeEvery(CREATE_INSURANCENEED_START, createInsuranceNeedAsync)
}

function* getIncomeAsync(action) {
  try {
    const response = yield call(getincomeAPI, action)
    if (response.status === 200 || 201) {
      yield put(getIncomeSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getIncomeFailure(error.response.data))
  }
}

function* getIncome() {
  yield takeEvery(GET_INCOME_START, getIncomeAsync)
}

// DELETE INSURANCE NEED API :
function* deleteInsuranceneedAsync(action) {
  try {
    const response = yield call(deleteInsuranceneedAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
      yield put(deleteInsuranceNeedSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(deleteInsuranceNeedFailure(error))
  }
}

function* DeleteInsuranceneed() {
  yield takeEvery(DELETE_INSURANCE_NEED_START, deleteInsuranceneedAsync)
}



// DELETE INSURANCE NEED API :
function* updateInsuranceneedAsync(action) {
  try {
    const response = yield call(UpdateInsuranceNeedAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
      yield put(updateInsuranceNeedSuccess(response?.data?.message || "Financial Planner Update Successfull"))
    } else {
      throw response
    }
  } catch (error) {
    yield put(updateInsuranceNeedFailed(error?.response?.data?.message ||"Financial Planner Update UnsuccessFull"))
  }
}

function* updateInsuranceneed() {
  yield takeEvery(UPDATE_INSURANCE_NEED, updateInsuranceneedAsync)
}

function* InsuranceNeedSaga() {
  yield all([
    fork(createInsuranceNeed),
    fork(getIncome),
    fork(getinsuranceneed),
    fork(DeleteInsuranceneed),
    fork(updateInsuranceneed),
  ])
}
export default InsuranceNeedSaga
